import Reflux from 'reflux';
/*
  ControlsActionsFactory

  Creates Reflux Actions for each video.
  Prevents multiple videos from listening and triggering the same actions.
*/
class ControlsActionsFactory{
  constructor() {
    this.actions = {};
  }
  get(videoId, route) {
    const key = `${videoId}${route.location.pathname}`;
    if(!this.actions[key]) {
      this.actions[key] = Reflux.createActions([
        'setCurrentTime',
        'setDuration',
        'setFullscreen',
        'setPause',
        'setVolume',
        'changeCurrentTime',
        'toggleFullscreen',
        'togglePlayPause',
        'changeVolume',
        'toggleMute',
        'init',
        'show'
      ]);
    }
    return this.actions[key];
  }
  clearCache() {
    Object.keys(this.actions).forEach((key)=> {
      delete this.actions[key]
    });
  }
}
export default new ControlsActionsFactory();



// WEBPACK FOOTER //
// ./medscape_modules/video/player-controls/controls-actions-factory.js